<template>
  <div class="invoice-pop" v-show="invoiceActive">
    <div class="pop-fp">
      <a class="close-btn" @click="invoiceActive = false">x</a>
      <div class="pop-fp-item">
        <div class="group">
          <label for="">收货人姓名:</label>
          <input type="text" v-model="consignee">
        </div>
        <div class="group">
          <label for="">收货人电话:</label>
          <input type="text" v-model="consigneePhone">
        </div>
        <div class="group group-city">
          <label for="">收货地址:</label>
          <label for="">省</label>
          <input type="text" v-model="province">
          <label for="">城市</label>
          <input type="text" v-model="city">
          <label for="">区</label>
          <input type="text" v-model="region">
        </div>
        <div class="group">
          <label for="">详细地址:</label>
          <input type="text" v-model="address">
        </div>
      </div>
      <span class="pop-fp-btn" @click="saveUserInfo">确认</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      invoiceActive: false,
      consignee: '', 
      consigneePhone: '',
      province: '',
      city: '',
      region: '',
      address: '',
      addressText: ''
    };
  },
  methods: {
    openInvoice() {
      this.invoiceActive = true;
      // this.getUserInfo(this.invoiceTitleType);
    },
    saveUserInfo() {
      let addressObj = {
        consignee: this.consignee.trim(), 
        consigneePhone: this.consigneePhone.trim(),
        province: this.province.trim(),
        city: this.city.trim(),
        region: this.region.trim(),
        address: this.address.trim(),
      }
      if (this.consignee.trim() == '') {
        this.$global.alert('收件姓名不能为空');
        return 
      }
      if (this.consigneePhone.trim() == '') {
        this.$global.alert('收件号码不能为空');
        return 
      }
      if (!this.$validate.checkPhone(this.consigneePhone)) {
        this.$global.alert('手机号码格式不正确');
        return 
      }
      if (this.province.trim() == '' || this.city.trim() == '' || this.region.trim() == '' || this.address.trim() == '') {
        this.$global.alert('地址不能为空');
        return 
      }
      this.invoiceActive = false;
      this.$emit("getAddress", addressObj)
    },
    getUserInfo(invoiceTitleType) {
      
    }
  }
};
</script>

<style scope>
.invoice-pop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.2);
  z-index: 5;
}
.invoice-pop .pop-fp {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 556px;
  background: #fff;
  border: 1px solid #9eaacb;
  box-shadow: 0 3px 4px #909090;
  margin: -278px 0 0 -299px;
  padding: 25px 17px 20px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  -ms-border-radius: 2px;
  border-radius: 5px;
}
.fl {
  float: left;
}
.invoice-pop .close-btn {
  position: absolute;
  right: 10px;
  top: 10px;
  width: 24px;
  height: 24px;
  background: #ecf3ff;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  color: #166fff;
  text-align: center;
  /* line-height: 22px; */
  font-size: 20px;
  text-decoration: none;
}
.invoice-pop .pop-fp-item h5 {
  font-size: 18px;
  /* line-height: 26px; */
  height: 26px;
  margin-bottom: 15px;
}
.invoice-pop .pop-fp-item h5 span {
  font-size: 16px;
  color: #818181;
  margin-left: 20px;
}
.invoice-pop .pop-fp-item h5 a {
  display: inline-block;
  margin-left: 20px;
  padding: 0 18px;
  background: #fff;
  font-size: 16px;
  /* line-height: 22px; */
  color: #323232;
  height: 24px;
  border: 1px solid #efefef;
  -webkit-border-radius: 30px;
  border-radius: 30px;
  font-weight: normal;
  vertical-align: top;
}
.invoice-pop .pop-fp-item h5 a.cur {
  background: #ecf3ff;
  border-color: #166fff;
  color: #166fff;
}
.invoice-pop .pop-fp-item {
  margin-bottom: 22px;
}
.invoice-pop .pop-fp-item div {
  height: 18px;
  line-height: 18px;
  font-size: 16px;
  margin-bottom: 15px;
}
.invoice-pop .pop-fp-item div.ipt-w input {
  width: 255px;
}
.invoice-pop .pop-fp-item div input {
  padding: 0 10px;
  height: 18px;
  border: 0;
  border-left: 1px solid #3179ff;
  width: 400px;
}
.invoice-pop .ipt-tit {
  width: 92px;
  text-align: right;
  margin-right: 15px;
}
.invoice-pop .pop-fp-btn {
  display: block;
  width: 100%;
  font-size: 18px;
  color: #fff;
  text-align: center;
  background: #166fff;
  line-height: 40px;
  height: 40px;
  text-decoration: none;
  cursor: pointer;
}
.invoice-pop .pop-fp-rules {
  font-size: 16px;
  margin-top: 10px;
}
.invoice-pop .pop-fp-rules dt {
  line-height: 30px;
}
.invoice-pop .pop-fp-rules dd {
  background: #f2f2f2;
  overflow: hidden;
  overflow-y: auto;
  height: 94px;
  padding: 10px;
}
.invoice-pop .pop-fp-rules dd p {
  line-height: 1.5;
}
.textarea-adress{
  border: 1px solid #ccc;
  padding: 10px;
  width: 530px;
  height: 60px;
}
.invoice-pop .pop-fp-item .group{
  margin-bottom:12px;
  height: 28px;
}
.invoice-pop .pop-fp-item .group input{
  padding: 3px 4px;
  height: 20px;
  font-size: 16px;
  color: #333;
  width: 300px;
  border: 1px solid #ccc;
}
.invoice-pop .pop-fp-item .group label:nth-of-type(1){
  width: 90px;
  display: inline-block;
}
.invoice-pop .pop-fp-item .group-city input{
  width: 80px;
}
.invoice-pop .pop-fp-item .group-city input:nth-of-type(3){
  width: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/invoice/Address.vue